import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-brand-bg" data-testid="site-layout">
      <Header />
      <main className="flex-1" data-testid="site-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
